// @ts-check
import { AuthService } from "@js/services/AuthService";
import { CaseService } from "@js/services/CaseService";
import { OrganisationService } from "@js/services/OrganisationService";
import { RoleService } from "@js/services/RoleService";
import { SelectListService } from "@js/services/SelectListService";
import { SharedDataService } from "@js/services/SharedDataService";
import { UserDashboardService } from "@js/services/UserDashboardService";
import { UserService } from "@js/services/UserService";
import { HasActiveLicense } from "@js/helpers/LicenseStatusHelper";

import {
  ApplicationUser,
  BrickflowEventLogClient,
  CaseAccessLevelEnum,
  CaseClient,
  CaseLenderClient,
  CaseLenderStateEnum,
  CaseMemberClient,
  CaseStatusEnum,
  CaseSummaryDTO,
  ClientClient,
  DealClient,
  DealLenderClient,
  DealLenderMessageClient,
  DevelopmentInput,
  DevelopmentInputClient,
  DevelopmentInputWithNoLoginClient,
  EventLogEnum,
  HubspotContactRequest,
  IntroducerClient,
  Invite,
  InviteClient,
  LenderClient,
  LenderProductTypeEnum,
  LicenseAppPackageClient,
  LicenseMasterStatusEnum,
  OrganisationClient,
  ProductTypeEnum,
  ShareDealDTO,
  StatusEnum,
  UserClient,
  UserRoleEnum,
  DashboardClient,
  GetSearchesForUserRequest,
  ProductFamilyEnum,
  GetCasesForUserRequest,
  AppraisalData,
  LicenseAppPackage,
  AssignBrokerToDealRequest,
  AssignLenderToDealRequest,
  StaticDataClient,
  Client,
  DevelopmentInputWithNoLogin,
  ApplicationUserCrudClient,
  DealFileAttachment,
  UserIdEmailPairDTO,
  OrganisationCrudClient,
} from "@src/apis/ModularClient";
import CaseLenderHelper from "@js/helpers/CaseLenderService";
import DealHelper from "@js/helpers/DealHelper";
import { Expand, getOneUsingOData } from "@ccq/ts-lib";
import { IndexService } from "@js/services/IndexService";
import { ODataHelper } from "@js/helpers/ODataHelper";
import { DealFileAttachmentHelper } from "@js/helpers/DealFileAttachmentHelper";
import { FileUploadProgressDTO } from "@js/DTO/FileUploadProgressDTO.cs";
import { FileAttachmentHelper } from "@js/helpers/FileAttachmentHelper";

enum NavMenuEnum {
  Home = 0,
  DevelopmentFinance = 1,
  BridgingFinance = 2,
  Clients = 3,
  CommercialMortgages = 4,
  EquityAndMezz = 5,
  ProfessionalServices = 6,
  VATBridging = 7,
  SecondaryMarket = 8,
  LenderMezzanine = 9,
  WholesaleCapital = 10,
}

export class UserDashboardController {
  isPageLoading: boolean = false;
  isCardView: boolean = true;

  cardWithOpenMenu = {
    id: null,
  };

  isSearchesLoading: boolean = false;
  searches: CaseSummaryDTO[];

  isDevFinanceProjectsLoading: boolean = false;
  isBridgingPreConProjectsLoading: boolean = false;
  isCommercialProjectsLoading: boolean = false;
  isAllProjectsLoading: boolean = false;
  projects: CaseSummaryDTO[];

  actionItem: CaseSummaryDTO;

  confirmSearchToDelete: boolean;
  confirmProjectToDelete: boolean;

  confirmCopyProjectName: boolean;
  newProjectName: string;

  currentUser: Expand<ApplicationUser>;
  hasEnterpriseLicense: boolean;

  //Share search
  newSearch: boolean = false;
  isResultScreen: boolean = true;
  existingborrower: number = null;
  showClientDetails: boolean = false;
  existingUsers: UserIdEmailPairDTO[] = [];
  clientId?: number = null;
  loanCriteria: DevelopmentInput;
  displayMsg: string;
  sharedSearch: boolean = false;
  showShareResults: number;
  isBridging: boolean = false;

  shareDealDto: ShareDealDTO;

  selectedNavMenu: NavMenuEnum;

  DashboardTypeEnum = {
    Home: 0,
    Searches: 1,
    Projects: 2,
    Introductions: 3,
  };

  selectedDashboardType: number;

  //isNewSearchSelect: boolean;

  homeScreenCount: number = 3;

  isAdmin: boolean = false;
  isBroker: boolean = false;
  isLender: boolean = false;
  isBorrower: boolean = false;
  isIntroducer: boolean = false;
  isOrganisationAdmin: boolean = false;

  shareSearchModal: number = null;
  shareSearchErrorDisplayed: boolean = false;

  // Introducer variables
  introduceClientModal: number = null;
  clientFirstName: string;
  clientSurname: string;
  clientEmail: string;
  clientPhoneNumber: string;

  isProcessingSend: boolean = false;

  invite: Invite;
  invitedUsers: Invite[] = [];

  introducedUsers: ApplicationUser[];

  savedIntroducedSearches: DevelopmentInput[] = [];
  unsavedIntroducedSearches: DevelopmentInputWithNoLogin[] = [];

  clientAdminTools: boolean = false;
  userSearchResults: ApplicationUser[];

  selectedUser: ApplicationUser;
  selecteduserName: string;
  selectedBorrowerId: number;
  //viewAsClientUserName: string;
  viewAsClientFirstName: string;
  selectedClientName: string;
  //TODO - these need to be related to the enums and moved into a "LookupService" so that we're only defining them once
  locations: Array<{ id: number; value: string }> = [
    { id: 0, value: "Any" },
    { id: 1, value: "London" },
    { id: 2, value: "North West" },
    { id: 4, value: "Midlands" },
    { id: 8, value: "East of England" },
    { id: 16, value: "South East" },
    { id: 32, value: "South West" },
    { id: 64, value: "North East" },
    { id: 128, value: "Wales" },
    { id: 256, value: "Scotland" },
    { id: 512, value: "Northern Ireland" },
  ];
  propertyTypes: Array<{ id: number; value: string }> = [
    { id: 0, value: "Any" },
    { id: 1, value: "Residential" },
    { id: 2, value: "Mixed Use" },
    { id: 2048, value: "Licenced HMO" },
    { id: 4, value: "Hotel" },
    { id: 8, value: "Leisure" },
    { id: 16, value: "Care Home" },
    { id: 32, value: "Medical" },
    { id: 64, value: "Office" },
    { id: 128, value: "Retail" },
    { id: 256, value: "Light Industrial" },
    { id: 512, value: "Student" },
    { id: 1024, value: "Heavy Industrial" },
    { id: 4096, value: "Land without Planning" },
    { id: 8192, value: "Education" },
    { id: 16384, value: "Retirement" },
  ];

  // end of Introducer variables

  // Start of dashboard search variables

  //caseStatuses: Array<{ id: number, value: string, order: number }> = [{ id: 999, value: 'Search', order: 1 }, { id: 0, value: 'New Project', order: 2 }, { id: 1, value: 'DIP In Progress', order: 3 }, { id: 2, value: 'Under Review', order: 4 }, { id: 3, value: 'Ready To Submit', order: 5 }, { id: 4, value: 'Submitted To Lenders For DIP', order: 6 }, { id: 12, value: 'Ready to be Re-submitted to Lenders For DIP', order: 6 }, { id: 5, value: 'Applied', order: 7 }]; //, { id: 9, value: "Submitted To Lenders Pending Review", order: 12 }
  lenderCaseStatuses: Array<{ id: number; value: string; order: number }> = [
    { id: 1, value: "Case to review", order: 2 },
    { id: 2, value: "DIP submitted", order: 3 },
    { id: 3, value: "Case rejected", order: 4 },
    { id: 4, value: "DIP withdrawn", order: 5 },
    { id: 10, value: "DIP submitted and accepted", order: 6 },
  ];

  // Status filter for non-lenders
  filterStatuses: Array<{ id: number; value: string; order: number }> = [
    { id: 1, value: "Search", order: 2 },
    { id: 2, value: "Case in Progress", order: 3 },
    { id: 3, value: "Submitted to Lender", order: 4 },
    { id: 8, value: "Ready to Re-Submit to Lenders", order: 4.5 },
    { id: 4, value: "DIP: Offered", order: 5 },
    { id: 5, value: "DIP: Rejected", order: 6 },
    { id: 6, value: "DIP: Withdrawn", order: 7 },
    { id: 7, value: "Applied to Lender", order: 8 },
  ];

  clientCaseNameFilter: string = null;
  statusFilter: number = undefined;
  caseStatusFilter: CaseStatusEnum = null;
  dipStatusFilter: CaseLenderStateEnum = null;
  brokerOrganisationFilter: number | null = null;

  // end of dashboard search variables

  licenseStatus: LicenseMasterStatusEnum;
  showPaymentModal: boolean;
  selectedResult: number;
  dataLoading: boolean = false;
  introducerErrorDisplayed: boolean = false;

  isUpgradedUser: boolean = false;
  isAssignedUserToOrg: boolean = false;

  showLogOutModal: boolean = false;

  addToHubspot: boolean = false;

  selectedSearch: CaseSummaryDTO;

  confirmAssignBrokerSearch: boolean = false;
  confirmAssignLenderSearch: boolean = false;
  licensedOrganisationBrokers: ApplicationUser[];
  lenderUsers: ApplicationUser[];
  selectedBroker: ApplicationUser;
  selectedLender: ApplicationUser;
  lenderList: ApplicationUser[] = [];
  showDeletedSearchMessageModal: boolean = false;
  borrowerMessage: string = null;
  showMessageToborrower: boolean = false;
  showContactBrokerModal: boolean = false;

  productTypeOptions = [];

  //hiding and showing briding option.
  hasBridging: boolean = false;

  //hiding and showing commercial option.
  hasCommercial: boolean = false;

  isDeallockerIntegrationEnabled: boolean = false;

  isProfessionalServicesEnabled: boolean = false;

  //Hiding menus for every one.
  hideDevfinanceMenu: boolean = true;
  hideBridgingMenu: boolean = true;
  hideCommercialMenu: boolean = true;

  //Hiding search for lenders.
  hasLiveSearch: boolean = true;
  hideDevelopmentFinanceSearch: boolean = false;
  hideBridgingSearch: boolean = false;
  hideCommercialSearch: boolean = false;

  // Boolean to send search email to client
  emailClient: boolean = false;

  showLenderTerms: boolean = false;
  lenderSelectedProject: CaseSummaryDTO;

  isCommercialOwnerOccupiedActive: boolean = false;
  goToDealForumClicked: boolean = false;
  assignedLenders = {};

  bridgingTotalUnreadMessage: number = 0;
  commercialTotalUnreadMessage: number = 0;
  devfinanceTotalUnreadMessage: number = 0;
  deallockerTabSelected: number = 1;
  professionalServicesTabSelected: number = 1;

  vatBridgingPurchasePrice: number;
  showVatBridgingMessage: boolean = false;
  getQuoteForm: ng.IFormController;
  acceptTerms: boolean;
  uploadingFiles: FileUploadProgressDTO[] = [];
  fileUpload: DealFileAttachment[];
  displaySuccessModal: boolean = false;

  brokerOrganisations: { id: number; name: string }[];

  static $inject = [
    "$rootScope",
    "$routeParams",
    "$location",
    "DevelopmentInputClient",
    "DevelopmentInputWithNoLoginClient",
    "CaseService",
    "CaseClient",
    "RoleService",
    "AuthService",
    "IntroducerClient",
    "DashboardClient",
    "CaseMemberClient",
    "InviteClient",
    "OrganisationService",
    "OrganisationClient",
    "LicenseAppPackageClient",
    "CaseLenderClient",
    "UserClient",
    "SelectListService",
    "ClientClient",
    "DealClient",
    "LenderClient",
    "DealLenderClient",
    "DealLenderMessageClient",
    "SharedDataService",
    "StaticDataClient",
    "UserDashboardService",
    "UserService",
    "BrickflowEventLogClient",
    "ApplicationUserCrudClient",
    "IndexService",
    "ODataHelper",
    "$cookies",
    "$timeout",
    "FileAttachmentHelper",
    "OrganisationCrudClient",
  ];

  constructor(
    private $rootScope: ng.IRootScopeService,
    private $routeParams: ng.route.IRouteParamsService,
    private $location: ng.ILocationService,
    private developmentInputClient: DevelopmentInputClient,
    private developmentInputWithNoLoginClient: DevelopmentInputWithNoLoginClient,
    private $CaseService: CaseService,
    private caseClient: CaseClient,
    private roleService: RoleService,
    private authService: AuthService,
    private introducerClient: IntroducerClient,
    private dashboardClient: DashboardClient,
    private caseMemberClient: CaseMemberClient,
    private inviteClient: InviteClient,
    private organisationService: OrganisationService,
    private organisationClient: OrganisationClient,
    private licenseAppPackageClient: LicenseAppPackageClient,
    private caseLenderClient: CaseLenderClient,
    private userService: UserClient,
    private selectListService: SelectListService,
    private clientClient: ClientClient,
    private dealClient: DealClient,
    private lenderClient: LenderClient,
    private dealLenderClient: DealLenderClient,
    private dealLenderMessageClient: DealLenderMessageClient,
    private sharedDataService: SharedDataService,
    private staticDataClient: StaticDataClient,
    private userDashboardService: UserDashboardService,
    private $user: UserService,
    private eventLogClient: BrickflowEventLogClient,
    private applicationUserCrudClient: ApplicationUserCrudClient,
    private indexService: IndexService,
    private odataHelper: ODataHelper,
    private $cookies: ng.cookies.ICookiesService,
    private $timeout: ng.ITimeoutService,
    private fileAttachmentHelper: FileAttachmentHelper,
    private organisationCrudClient: OrganisationCrudClient,
  ) {
    (this.$rootScope as any).isInvitedAndHasReadonlyAccess = false;

    DealHelper.setShowSearchNameAndUserSelectionModal(true);

    this.staticDataClient.isCommercialOwnerOccupiedActive().then((response) => {
      this.isCommercialOwnerOccupiedActive = response;
    });

    if (sessionStorage.getItem("returningFromdeletedSearch")) {
      this.showDeletedSearchMessageModal = true;
    }

    this.isUpgradedUser = sessionStorage.getItem("isUpgradedUser") == "true";
    this.isAssignedUserToOrg = sessionStorage.getItem("assignUserToOrg") == "true";

    //This removes most of the localstorage and session storage data.
    this.authService.clearStorageData();

    this.productTypeOptions = this.selectListService.GetProductTypeOptions(true);

    this.isPageLoading = true;

    if ($cookies.get("access_token")) {
      this.initializeUserRoles();
    }
    // Will hit here if the user has come from the payment page
    if (this.$routeParams.licensemasterId) {
      if (this.$routeParams.licensemasterId == "0") {
        this.showPaymentModal = true;
      } else {
        this.licenseAppPackageClient.fetch(this.$routeParams.licensemasterId).then((license: LicenseAppPackage) => {
          this.licenseStatus = license.status;
          if (
            license.status == LicenseMasterStatusEnum.PreSubscription ||
            LicenseMasterStatusEnum.None ||
            LicenseMasterStatusEnum.Unpaid ||
            license.status == LicenseMasterStatusEnum.PayFailure ||
            license.status == LicenseMasterStatusEnum.PaidUp
          ) {
            this.showPaymentModal = true;
          }
        });
      }
      this.addToHubspot = true;
    } else if (this.isAssignedUserToOrg) {
      this.showLogOutModal = true;
    }

    this.dealLenderMessageClient.getTotalUnreadMessagesByProductType().then((response) => {
      this.bridgingTotalUnreadMessage = response.bridgingTotalUnreadMessages;
      this.commercialTotalUnreadMessage = response.commercialTotalUnreadMessages;
      this.devfinanceTotalUnreadMessage = response.devFinanceTotalUnreadMessages;
    });
  }

  private async getCurrentUser() {
    return getOneUsingOData(this.applicationUserCrudClient, {
      filter: { id: { eq: await this.indexService.currentUserId } },
    });
  }

  getProjectsAndSearches() {
    sessionStorage.setItem("selectedNavMenu", this.selectedNavMenu.toString());
    if (this.isBorrower || this.isBroker || this.isAdmin || this.isIntroducer || this.isLender) {
      //only get searches if user might have any
      this.getSearches(this.homeScreenCount);
    } else {
      this.homeScreenCount = 6; //for lender
    }
    this.getProjects(this.homeScreenCount);
  }

  showHomeDashboard() {
    this.selectedDashboardType = this.DashboardTypeEnum.Home;
    if (sessionStorage.getItem("selectedNavMenu") && this.isValidPreviousPath()) {
      this.selectedNavMenu = parseInt(sessionStorage.getItem("selectedNavMenu"));
    } else {
      this.selectedNavMenu = NavMenuEnum.Home;
    }

    if (sessionStorage.getItem("clientCaseNameFilter") && this.isValidPreviousPath()) {
      this.clientCaseNameFilter = sessionStorage.getItem("clientCaseNameFilter");
    }

    if (sessionStorage.getItem("statusFilter") && this.isValidPreviousPath()) {
      this.statusFilter = parseInt(sessionStorage.getItem("statusFilter"));
      this.mapFilterStatus();
    }

    this.getProjectsAndSearches();
  }

  showEquityAndMezzDashboard() {
    this.selectedNavMenu = NavMenuEnum.EquityAndMezz;
    this.selectedDashboardType = this.DashboardTypeEnum.Home;
    this.userDashboardService.resetGoToNavMenu();
  }

  showProfessionalServicesDashboard() {
    if (this.isProfessionalServicesEnabled) {
      this.selectedNavMenu = NavMenuEnum.ProfessionalServices;
      this.selectedDashboardType = this.DashboardTypeEnum.Home;
    }
  }

  showSecondaryMarketDashboard() {
    this.selectedNavMenu = NavMenuEnum.SecondaryMarket;
    this.selectedDashboardType = this.DashboardTypeEnum.Home;
  }

  showLenderMezzanineDashboard() {
    this.selectedNavMenu = NavMenuEnum.LenderMezzanine;
    this.selectedDashboardType = this.DashboardTypeEnum.Home;
  }

  showWholesaleCapitalDashboard() {
    this.selectedNavMenu = NavMenuEnum.WholesaleCapital;
    this.selectedDashboardType = this.DashboardTypeEnum.Home;
  }

  uploadSecondaryMarketFile(files: File[]) {
    const allowedTypes = ["image/png", "image/jpeg"];
    const invalidFile = files.find((f) => !allowedTypes.includes(f.type));

    if (invalidFile) {
      alert("Only PNG or JPG files are allowed.");
      return;
    }

    this.fileAttachmentHelper
      .uploadFileAndReturnURI(files)
      .then((res) => this.dashboardClient.sendSecondaryMarketEmail(res))
      .then((_) => {
        this.displaySuccessModal = true;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  showVATBridgingDashboard() {
    this.isPageLoading = true;
    this.userService
      .logEventAndMarkVatBridgingTabClicked("VATBRIDGING-TAB-CLICKED")
      .then(() => {
        if (this.currentUser && !this.currentUser.isVATBridgingTabClicked) {
          this.currentUser.isVATBridgingTabClicked = true;
        }
      })
      .finally(() => {
        this.isPageLoading = false;
        this.selectedNavMenu = NavMenuEnum.VATBridging;
        this.selectedDashboardType = this.DashboardTypeEnum.Home;
      });
  }

  logEvent(eventName) {
    this.eventLogClient.logEvent(
      eventName,
      EventLogEnum.VATBridging,
      ProductTypeEnum.None,
      0,
      "",
      `${this.currentUser.fullName} (${this.currentUser.email})`,
    );
  }

  showDevelopmentFinanceDashboard() {
    this.selectedNavMenu = NavMenuEnum.DevelopmentFinance;
    this.selectedDashboardType = this.DashboardTypeEnum.Home;
    //this.isNewSearchSelect = false;

    this.getProjectsAndSearches();
  }

  showBridgingDashboard() {
    if (this.hasBridging) {
      this.selectedNavMenu = NavMenuEnum.BridgingFinance;
      this.selectedDashboardType = this.DashboardTypeEnum.Home;
      //this.isNewSearchSelect = false;

      //TODO JLH remove
      //this.selectedDashboardType = this.DashboardTypeEnum.home;

      this.getProjectsAndSearches();
    }
  }

  showCommercialDashboard() {
    if (this.hasCommercial) {
      this.selectedNavMenu = NavMenuEnum.CommercialMortgages;
      this.selectedDashboardType = this.DashboardTypeEnum.Home;
      // this.isNewSearchSelect = false;
      this.getProjectsAndSearches();
    }
  }

  showDevFinanceSearchDashboard() {
    this.selectedDashboardType = this.DashboardTypeEnum.Searches;
    //this.isNewSearchSelect = false;
    this.getSearches(0);
  }

  showProjectDashboard() {
    this.selectedDashboardType = this.DashboardTypeEnum.Projects;
    //this.isNewSearchSelect = false;
    this.getProjects(0);
  }

  checkSearchPermission(): boolean {
    if (this.selectedNavMenu == NavMenuEnum.Home) {
      return true;
    }

    if (this.selectedNavMenu == NavMenuEnum.DevelopmentFinance && !this.hideDevelopmentFinanceSearch) {
      return true;
    }

    if (this.selectedNavMenu == NavMenuEnum.BridgingFinance && !this.hideBridgingSearch) {
      return true;
    }

    if (this.selectedNavMenu == NavMenuEnum.CommercialMortgages && !this.hideCommercialSearch) {
      return true;
    }
    return false;
  }

  getSearches(count: number) {
    if (this.dipStatusFilter) {
      this.searches = [];
      return;
    }

    this.isSearchesLoading = true;

    this.searches = [];

    var userName = this.currentUser.userName;

    let r: GetSearchesForUserRequest = {
      productType: ProductTypeEnum.None,
      productFamily: ProductFamilyEnum.None,
      userName: userName,
      searchText: this.clientCaseNameFilter,
      statusFilter: this.caseStatusFilter,
      limit: count,
      brokerOrganisationId: this.brokerOrganisationFilter,
    };

    if (this.selectedNavMenu == NavMenuEnum.DevelopmentFinance) {
      r.productFamily = ProductFamilyEnum.Development;
      this.dashboardClient
        .getSearchesForUser(r)
        .then((response) => {
          if (this.selectedNavMenu == NavMenuEnum.DevelopmentFinance) {
            this.searches = response.results;
            this.isSearchesLoading = false;
          }
        })
        .catch((error) => {
          this.searches = [];
          this.isSearchesLoading = false;
        });
    } else if (this.selectedNavMenu == NavMenuEnum.BridgingFinance) {
      r.productFamily = ProductFamilyEnum.Bridging;
      this.dashboardClient
        .getSearchesForUser(r)
        .then((response) => {
          if (this.selectedNavMenu == NavMenuEnum.BridgingFinance) {
            this.searches = response.results;
            this.isSearchesLoading = false;
          }
        })
        .catch((error) => {
          this.searches = [];
          this.isSearchesLoading = false;
        });
    } else if (this.selectedNavMenu == NavMenuEnum.CommercialMortgages) {
      r.productFamily = ProductFamilyEnum.Commercial;
      this.dashboardClient
        .getSearchesForUser(r)
        .then((response) => {
          if (this.selectedNavMenu == NavMenuEnum.CommercialMortgages) {
            this.searches = response.results;
            this.isSearchesLoading = false;
          }
        })
        .catch((error) => {
          this.searches = [];
          this.isSearchesLoading = false;
        });
    } else {
      this.dashboardClient
        .getSearchesForUser(r)
        .then((response) => {
          if (this.selectedNavMenu == NavMenuEnum.Home) {
            this.searches = response.results;
            this.isSearchesLoading = false;
          }
        })
        .catch((error) => {
          this.searches = [];
          this.isSearchesLoading = false;
        });
    }
  }
  /**
   * Retrieves projects (appraisals) according to which menu option has been selected
   * @param count
   */
  //TODO: Use this
  getDealproject(count: number) {}
  /**
   * Retrieves projects (appraisals) according to which menu option has been selected
   * @param count
   */
  getProjects(count: number) {
    this.projects = [];

    var userName = this.currentUser.userName;

    let request: GetCasesForUserRequest = {
      productType: ProductTypeEnum.None,
      productFamily: ProductFamilyEnum.None,
      userName: userName,
      searchText: this.clientCaseNameFilter,
      statusFilter: this.caseStatusFilter,
      limit: count,
      dipStatus: this.dipStatusFilter,
      brokerOrganisationId: this.brokerOrganisationFilter,
    };

    if (this.selectedNavMenu == NavMenuEnum.DevelopmentFinance) {
      this.isDevFinanceProjectsLoading = true;
      request.productFamily = ProductFamilyEnum.Development;
      this.dashboardClient
        .getCasesForUser(request)
        .then((response) => {
          if (this.selectedNavMenu == NavMenuEnum.DevelopmentFinance) {
            this.projects = response.results;
            if (this.isLender) {
              this.projects.forEach((project) => {
                if (
                  project.productType == ProductTypeEnum.Development &&
                  project.dealID == null &&
                  project.caseID != null
                ) {
                  this.setAssignedLender(project.caseID, true);
                } else {
                  this.setAssignedLender(project.dealID);
                }
              });
            }
            this.isDevFinanceProjectsLoading = false;
          }
        })
        .then(() => {
          this.getTotalUnreadMessagesPerAppraisal();
        })
        .catch((error) => {
          this.projects = [];
          this.isDevFinanceProjectsLoading = false;
        });
    } else if (this.selectedNavMenu == NavMenuEnum.BridgingFinance) {
      this.isBridgingPreConProjectsLoading = true;
      request.productFamily = ProductFamilyEnum.Bridging;
      this.dashboardClient
        .getCasesForUser(request)
        .then((response) => {
          if (this.selectedNavMenu == NavMenuEnum.BridgingFinance) {
            this.projects = response.results;
            if (this.isLender) {
              this.projects.forEach((project) => {
                this.setAssignedLender(project.dealID);
              });
            }
            this.isBridgingPreConProjectsLoading = false;
          }
        })
        .then(() => {
          this.getTotalUnreadMessagesPerAppraisal();
        })
        .catch((error) => {
          this.projects = [];
          this.isBridgingPreConProjectsLoading = false;
        });
    } else if (this.selectedNavMenu == NavMenuEnum.CommercialMortgages) {
      this.isCommercialProjectsLoading = true;
      request.productFamily = ProductFamilyEnum.Commercial;

      this.dashboardClient
        .getCasesForUser(request)
        .then((response) => {
          if (this.selectedNavMenu == NavMenuEnum.CommercialMortgages) {
            this.projects = response.results;
            if (this.isLender) {
              this.projects.forEach((project) => {
                this.setAssignedLender(project.dealID);
              });
            }
            this.isCommercialProjectsLoading = false;
          }
        })
        .then(() => {
          this.getTotalUnreadMessagesPerAppraisal();
        })
        .catch((error) => {
          this.projects = [];
          this.isCommercialProjectsLoading = false;
        });
    } else {
      this.isAllProjectsLoading = true;
      request.productFamily = ProductFamilyEnum.None;
      this.dashboardClient
        .getCasesForUser(request)
        .then((response) => {
          if (this.selectedNavMenu == NavMenuEnum.Home) {
            this.projects = response.results;
            if (this.isLender) {
              this.projects.forEach((project) => {
                if (
                  project.productType == ProductTypeEnum.Development &&
                  project.dealID == null &&
                  project.caseID != null
                ) {
                  this.setAssignedLender(project.caseID, true);
                } else {
                  this.setAssignedLender(project.dealID);
                }
              });
            }
            this.isAllProjectsLoading = false;
          }
        })
        .then(() => {
          this.getTotalUnreadMessagesPerAppraisal();
        })
        .catch((error) => {
          this.projects = [];
          this.isAllProjectsLoading = false;
        });
    }
  }

  //toggleCardTableView() {
  //    // hide any open menus
  //    this.closeTileMenu();

  //    this.isCardView = !this.isCardView;
  //}

  filterProjectsAndSearches() {
    if (this.clientCaseNameFilter != null) sessionStorage.setItem("clientCaseNameFilter", this.clientCaseNameFilter);
    if (this.statusFilter != null) sessionStorage.setItem("statusFilter", this.statusFilter.toString());
    if (this.brokerOrganisationFilter != null)
      sessionStorage.setItem("brokerOrganisationFilter", this.brokerOrganisationFilter.toString());

    //TODO - what is this code doing?!
    if (this.selecteduserName) {
      this.selecteduserName = this.selecteduserName; // this is baffling!
    } else if ((this.$rootScope as any).clientUsernameBeingViewed) {
      this.selecteduserName = (this.$rootScope as any).clientUsernameBeingViewed;
    } else {
      this.selecteduserName = this.currentUser.userName;
    }

    if (this.selecteduserName !== this.currentUser.userName) {
      this.userService.searchByEmail(this.selecteduserName).then((users) => {
        this.selectedUser = users[0];
      });
    }
    // end of todo

    this.mapFilterStatus();

    if (this.selectedDashboardType == this.DashboardTypeEnum.Home) {
      this.getProjectsAndSearches();
    } else if (this.selectedDashboardType == this.DashboardTypeEnum.Searches) {
      this.showDevFinanceSearchDashboard();
    } else if (this.selectedDashboardType == this.DashboardTypeEnum.Projects) {
      this.showProjectDashboard();
    }
  }

  /**Map the combined status filter dropdown to the correct enum filter (case/caselender) */
  mapFilterStatus() {
    if (this.statusFilter == undefined || isNaN(this.statusFilter)) {
      this.caseStatusFilter = null;
      this.dipStatusFilter = null;
      return;
    }

    if (this.isLender) {
      this.caseStatusFilter = null;
      this.dipStatusFilter = this.statusFilter;
    } else {
      switch (this.statusFilter) {
        case 1:
          this.caseStatusFilter = CaseStatusEnum.Search;
          this.dipStatusFilter = null;
          break;
        case 2:
          this.caseStatusFilter = CaseStatusEnum.NewCase;
          this.dipStatusFilter = null;
          break;
        case 3:
          this.caseStatusFilter = CaseStatusEnum.SubmittedToLendersForHoT;
          this.dipStatusFilter = null;
          break;
        case 4:
          this.caseStatusFilter = null;
          this.dipStatusFilter = CaseLenderStateEnum.Offered;
          break;
        case 5:
          this.caseStatusFilter = null;
          this.dipStatusFilter = CaseLenderStateEnum.Rejected;
          break;
        case 6:
          this.caseStatusFilter = null;
          this.dipStatusFilter = CaseLenderStateEnum.Withdrawn;
          break;
        case 7:
          this.caseStatusFilter = CaseStatusEnum.Applied;
          this.dipStatusFilter = null;
          break;
        case 8:
          this.caseStatusFilter = CaseStatusEnum.ReadyToReSubmit;
          this.dipStatusFilter = null;
          break;
        case 9:
          this.caseStatusFilter = CaseStatusEnum.SentToPackager;
          this.dipStatusFilter = null;
          break;
        case 0:
        default:
          this.caseStatusFilter = null;
          this.dipStatusFilter = null;
          break;
      }
    }
  }

  getCaseStatusText(status: CaseStatusEnum): string {
    var displayText = "";

    switch (status) {
      case CaseStatusEnum.NewCase:
        displayText = "CASE IN PROGRESS";
        break;
      case CaseStatusEnum.UnderReview:
        displayText = "UNDER ADMIN REVIEW";
        break;
      case CaseStatusEnum.ReadyToSubmit:
        displayText = "READY TO SUBMIT TO LENDERS";
        break;
      case CaseStatusEnum.SubmittedToLendersForHoT:
        displayText = "SUBMITTED TO LENDERS FOR DIP";
        break;
      case CaseStatusEnum.Applied:
        displayText = "APPLIED TO LENDER";
        break;
      case CaseStatusEnum.Completed:
        displayText = "COMPLETE";
        break;
      case CaseStatusEnum.SubmittedToLendersPendingReview:
        displayText = "SUBMITTED TO LENDERS PENDING REVIEW";
        break;
      case CaseStatusEnum.ReadyToReSubmit:
        displayText = "READY TO BE RE-SUBMITTED TO LENDERS FOR DIP";
        break;
      case CaseStatusEnum.SentToPackager:
        displayText =
          this.currentUser == null ? "" : this.currentUser.isConnectUser ? "SENT BY AR" : "SENT TO PACKAGER";
        break;
      default:
      case CaseStatusEnum.NewCase:
        displayText = "";
        break;
    }

    return displayText;
  }

  nFormatter(num: number, decimalPlaces: number) {
    const lookup = [
      { value: 1, symbol: "" },
      { value: 1e3, symbol: "k" },
      { value: 1e6, symbol: "M" },
      { value: 1e9, symbol: "G" },
      { value: 1e12, symbol: "T" },
      { value: 1e15, symbol: "P" },
      { value: 1e18, symbol: "E" },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup
      .slice()
      .reverse()
      .find(function (item) {
        return num >= item.value;
      });
    return item ? (num / item.value).toFixed(decimalPlaces).replace(rx, "$1") + item.symbol : "0";
  }

  isDateToday(date: Date) {
    if (date) {
      const today = new Date();

      if (
        today.getFullYear() === date.getFullYear() &&
        today.getMonth() === date.getMonth() &&
        today.getDate() === date.getDate()
      ) {
        return true;
      }
    }

    return false;
  }

  isDateYesterday(date: Date) {
    if (date) {
      var yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);

      if (
        yesterday.getFullYear() === date.getFullYear() &&
        yesterday.getMonth() === date.getMonth() &&
        yesterday.getDate() === date.getDate()
      ) {
        return true;
      }
    }

    return false;
  }

  getLastUpdated(date: Date): string {
    var displayValue: string;

    if (date) {
      if (this.isDateToday(date)) {
        displayValue = "Today";
      } else if (this.isDateYesterday(date)) {
        displayValue = "Yesterday";
      } else {
        displayValue = date.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
          year: "numeric",
        });
      }
    }

    return displayValue;
  }

  goToSearchResults(caseSummary: CaseSummaryDTO) {
    this.sharedDataService.cleanLenderReferralSessionStorage();
    if (caseSummary.productType != ProductTypeEnum.Development) {
      if (this.isSearchClickable(caseSummary.isOwner)) {
        if (
          caseSummary.productType == ProductTypeEnum.CommercialInvestment ||
          caseSummary.productType == ProductTypeEnum.CommercialOwnerOccupied
        ) {
          this.$location.path("/commercialresults/" + caseSummary.dealID);
        } else {
          this.$location.path("/bridgingresults/" + caseSummary.dealID);
        }
      }
    } else {
      if (this.isSearchClickable(caseSummary.isOwner)) {
        if (caseSummary.uniqueRef != null) {
          this.developmentInputWithNoLoginClient.isResultActive(caseSummary.uniqueRef).then((results) => {
            if (!results) {
              this.displayMsg = `Changes have been made to this search by your client, your user dashboard will now refresh`;
              this.showShareResults = 5;
            } else {
              this.$location.path("/referredSearch/" + caseSummary.uniqueRef);
            }
          });
        } else if (caseSummary.developmentInputId) {
          this.$location.path("/results/" + caseSummary.developmentInputId);
        } else if (caseSummary.dealID) {
          this.$location.path("/devfinanceresults/" + caseSummary.dealID);
        }
      }
    }
  }

  goToProject(project: CaseSummaryDTO) {
    this.sharedDataService.cleanLenderReferralSessionStorage();
    if ((this.roleService.IsLender && this.showLenderTerms) || !this.roleService.IsLender) {
      if (this.roleService.IsLender && this.showLenderTerms) {
        project = { ...this.lenderSelectedProject };
      }

      if (this.roleService.IsLender && this.goToDealForumClicked) {
        this.goToDealForum(project);
      } else {
        if (this.isProjectClickable(project.isInvitedToCase)) {
          if (project.isInvitedAndHasReadonlyAccess) {
            (this.$rootScope as any).isInvitedAndHasReadonlyAccess = true;
            this.$rootScope.$broadcast("invitedStatusChange");
          }
          if (
            project.productType == ProductTypeEnum.BridgingPreconstruction ||
            project.productType == ProductTypeEnum.BridgingPurchaseOrRefinance ||
            project.productType == ProductTypeEnum.BridgingDeveloperExit ||
            project.productType == ProductTypeEnum.BridgingRefurb
          ) {
            this.$location.path("/bridgingcasedashboard/" + project.dealID);
          } else if (
            project.productType == ProductTypeEnum.CommercialInvestment ||
            project.productType == ProductTypeEnum.CommercialOwnerOccupied
          ) {
            this.$location.path("/commercialcasedashboard/" + project.dealID);
          } else if (project.productType == ProductTypeEnum.Development) {
            if (project.dealID) {
              this.$location.path("/devfinancecasedashboard/" + project.dealID);
            } else {
              this.$location.path("/casedashboard/" + project.caseID);
            }
          }
        }
      }
    } else if (this.roleService.IsLender && !this.showLenderTerms) {
      this.showLenderTerms = true;
      this.lenderSelectedProject = { ...project };
    }
  }

  goToNewSearch() {
    this.sharedDataService.cleanLenderReferralSessionStorage();
    // If the current user is a broker and doesn't have a subscription then don't allow them to create a new search
    if (this.isBroker && !this.currentUser.hasActiveSubscription) {
      return;
    }

    if (!this.isPageLoading) {
      (this.$rootScope as any).loanCriteria = null;

      if (this.isAdmin || (this.currentUser && this.currentUser.subscriptionStatus) || this.isLender) {
        this.authService.setHasValidStatustoShowShareSearchModal(true);
      }

      if (this.selectedNavMenu == NavMenuEnum.DevelopmentFinance && !this.hideDevelopmentFinanceSearch) {
        this.goToNewDevFinanceSearch();
      }

      if (this.selectedNavMenu == NavMenuEnum.BridgingFinance && !this.hideBridgingSearch) {
        this.goToNewBridgingFinanceSearch();
      }

      if (this.selectedNavMenu == NavMenuEnum.CommercialMortgages && !this.hideCommercialSearch) {
        this.goToNewCommercialSearch();
      }

      if (
        this.selectedNavMenu == NavMenuEnum.Home ||
        this.selectedNavMenu == NavMenuEnum.EquityAndMezz ||
        this.selectedNavMenu == NavMenuEnum.ProfessionalServices ||
        this.selectedNavMenu == NavMenuEnum.VATBridging ||
        this.selectedNavMenu == NavMenuEnum.SecondaryMarket ||
        this.selectedNavMenu == NavMenuEnum.LenderMezzanine ||
        this.selectedNavMenu == NavMenuEnum.WholesaleCapital
      ) {
        this.$location.path("/allloans");
      }
    }
  }

  goToNewProject() {
    this.isPageLoading = true;
    this.roleService.isBroker().then((isBroker: boolean) => {
      this.$CaseService.newBlankCase(!isBroker).then((newBlankCaseDto) => {
        if (newBlankCaseDto && newBlankCaseDto.NewCaseId) {
          this.$location.path("/casedashboard/" + newBlankCaseDto.NewCaseId);
        }

        this.isPageLoading = false;
      });
    });
  }

  goToNewBridgingSearch() {
    if (this.hasBridging) {
      this.$location.path("/bridgingcriteria/");
    }
  }

  goToNewCommercialSearch() {
    if (this.hasCommercial) {
      this.$location.path("/commercialcriteria");
    }
  }

  goToAllLoanPage() {
    this.$location.path("/allloans");
  }

  goToPurchaseOrRefinanceSearch() {
    if (this.hasBridging) {
      this.$location.path("/purchaserefinancecriteria/");
    }
  }

  goToNewDevFinanceSearch() {
    this.$location.path("/devfinancecriteria");
  }

  goToNewBridgingFinanceSearch() {
    this.$location.path("/bridgingcriteria");
  }

  deleteSearchConfirmation(dataItem) {
    this.closeTileMenu();
    event.stopPropagation();
    this.actionItem = dataItem;

    if (this.actionItem.isDevInputWithNoLogin) {
      this.developmentInputWithNoLoginClient.isResultActive(this.actionItem.uniqueRef).then((results) => {
        if (!results) {
          this.displayMsg = `Changes have been made to this search by your client, your user dashboard will now refresh`;
          this.showShareResults = 5;
        } else {
          this.confirmSearchToDelete = true;
        }
      });
    } else {
      this.confirmSearchToDelete = true;
    }
  }

  showAssignBrokerSearchModal(dataItem) {
    this.closeTileMenu();
    event.stopPropagation();
    this.actionItem = dataItem;
    this.confirmAssignBrokerSearch = true;
    this.selectedBroker = this.licensedOrganisationBrokers.find(
      (b) =>
        b.id ==
        (this.currentUser?.isConnectUser && this.actionItem.isReferredToConnect
          ? this.actionItem.connectUserId
          : this.actionItem.brokerUserId),
    );
  }

  showAssignLenderSearchModal(dataItem) {
    this.closeTileMenu();
    event.stopPropagation();
    this.actionItem = dataItem;
    this.getLenderUsersList();
    if (
      this.actionItem.productType == ProductTypeEnum.Development &&
      this.actionItem.dealID == null &&
      this.actionItem.caseID != null
    ) {
      this.caseLenderClient
        .fetchCaseLender(this.actionItem.caseID)
        .then((response) => {
          return this.userService.getUserByUserId(response.assignedLenderUserId);
        })
        .then((response) => {
          if (response != null) {
            this.selectedLender = response;
          }
        })
        .finally(() => {
          this.confirmAssignLenderSearch = true;
        });
    } else {
      this.dealLenderClient
        .fetchDealLender(this.actionItem.dealID)
        .then((response) => {
          return this.userService.getUserByUserId(response.assignedLenderUserId);
        })
        .then((response) => {
          if (response != null) {
            this.selectedLender = response;
          }
        })
        .finally(() => {
          this.confirmAssignLenderSearch = true;
        });
    }
  }

  assignBrokerToSearch(assignBrokerId) {
    this.confirmAssignBrokerSearch = false;
    this.isPageLoading = true;

    if (this.actionItem.productType == ProductTypeEnum.Development && this.actionItem.dealID == null) {
      if (this.actionItem.caseID) {
        this.caseClient
          .setBrokerUser(this.actionItem.caseID, assignBrokerId)
          .then((success) => {
            if (success) {
              this.getProjects(this.selectedDashboardType == this.DashboardTypeEnum.Home ? this.homeScreenCount : 0);
            } else {
              this.displayMsg = "We were unable to assign the broker to the case at this time, please try again later.";
              this.showShareResults = 4;
            }
          })
          .finally(() => {
            this.actionItem = null;
            this.isPageLoading = false;
            this.selectedBroker = null;
          });
      } else {
        this.developmentInputClient
          .assignBrokerToSearch(
            this.actionItem.developmentInputId,
            assignBrokerId,
            this.actionItem.isDevInputWithNoLogin,
          )
          .then((success) => {
            if (success) {
              this.getSearches(this.selectedDashboardType == this.DashboardTypeEnum.Home ? this.homeScreenCount : 0);
            } else {
              this.displayMsg =
                "We were unable to assign the broker to the search at this time, please try again later.";
              this.showShareResults = 4;
            }
          })
          .finally(() => {
            this.actionItem = null;
            this.isPageLoading = false;
            this.selectedBroker = null;
          });
      }
    } else {
      let request: AssignBrokerToDealRequest = {
        dealId: this.actionItem.dealID,
        brokerUserId: assignBrokerId,
      };
      this.dealClient
        .assignBrokerToDeal(request)
        .then((success) => {
          if (success) {
            if (this.actionItem.caseStatus == CaseStatusEnum.Search) {
              this.getSearches(this.selectedDashboardType == this.DashboardTypeEnum.Home ? this.homeScreenCount : 0);
            } else {
              this.getProjects(this.selectedDashboardType == this.DashboardTypeEnum.Home ? this.homeScreenCount : 0);
            }
          } else {
            this.displayMsg = "There was a problem assigning the broker, please try later.";
            this.showShareResults = 4;
          }
        })
        .finally(() => {
          this.actionItem = null;
          this.isPageLoading = false;
          this.selectedBroker = null;
        });
    }
  }

  assignLenderToSearch(assignLenderId) {
    this.confirmAssignLenderSearch = false;
    this.isPageLoading = true;

    if (
      this.actionItem.productType == ProductTypeEnum.Development &&
      this.actionItem.dealID == null &&
      this.actionItem.caseID != null
    ) {
      let request: AssignLenderToDealRequest = {
        dealId: this.actionItem.caseID,
        lenderId: this.currentUser.lenderId,
        lenderUserId: assignLenderId,
      };
      this.caseClient
        .assignLenderToCase(request)
        .then((success) => {
          if (success) {
            if (this.actionItem.caseStatus == CaseStatusEnum.Search) {
              this.getSearches(this.selectedDashboardType == this.DashboardTypeEnum.Home ? this.homeScreenCount : 0);
            } else {
              this.getProjects(this.selectedDashboardType == this.DashboardTypeEnum.Home ? this.homeScreenCount : 0);
            }
            this.setAssignedLender(this.actionItem.caseID);
          } else {
            this.displayMsg = "There was a problem assigning the lender, please try later.";
            this.showShareResults = 4;
          }
        })
        .finally(() => {
          this.actionItem = null;
          this.isPageLoading = false;
          this.selectedLender = null;
          this.lenderList = null;
        });
    } else {
      let request: AssignLenderToDealRequest = {
        dealId: this.actionItem.dealID,
        lenderId: this.currentUser.lenderId,
        lenderUserId: assignLenderId,
      };
      this.dealClient
        .assignLenderToDeal(request)
        .then((success) => {
          if (success) {
            if (this.actionItem.caseStatus == CaseStatusEnum.Search) {
              this.getSearches(this.selectedDashboardType == this.DashboardTypeEnum.Home ? this.homeScreenCount : 0);
            } else {
              this.getProjects(this.selectedDashboardType == this.DashboardTypeEnum.Home ? this.homeScreenCount : 0);
            }
            this.setAssignedLender(this.actionItem.dealID);
          } else {
            this.displayMsg = "There was a problem assigning the lender, please try later.";
            this.showShareResults = 4;
          }
        })
        .finally(() => {
          this.actionItem = null;
          this.isPageLoading = false;
          this.selectedLender = null;
          this.lenderList = null;
        });
    }
  }

  setAssignedLender(caseId: number, oldDevFinance: boolean = false) {
    if (oldDevFinance) {
      this.caseLenderClient
        .fetchCaseLender(caseId)
        .then((response) => {
          return this.userService.getUserByUserId(response.assignedLenderUserId);
        })
        .then((response) => {
          if (response != null) {
            this.assignedLenders[caseId] = response.fullName;
          } else {
            this.assignedLenders[caseId] = null;
          }
        })
        .catch(() => {
          this.assignedLenders[caseId] = null;
        });
    } else {
      this.dealLenderClient
        .fetchDealLender(caseId)
        .then((response) => {
          return this.userService.getUserByUserId(response.assignedLenderUserId);
        })
        .then((response) => {
          if (response != null) {
            this.assignedLenders[caseId] = response.fullName;
          } else {
            this.assignedLenders[caseId] = null;
          }
        })
        .catch(() => {
          this.assignedLenders[caseId] = null;
        });
    }
  }

  checkAssignedLender(selectedCase: CaseSummaryDTO) {
    if (
      selectedCase.productType == ProductTypeEnum.Development &&
      selectedCase.dealID == null &&
      selectedCase.caseID != null
    ) {
      return this.assignedLenders[selectedCase.caseID] != null;
    } else {
      return this.assignedLenders[selectedCase.dealID] != null;
    }
  }

  getLenderUsersList() {
    this.lenderList = [];
    this.lenderUsers?.forEach((user) => {
      if (user.isLenderAdmin) {
        this.lenderList.push(user);
      } else {
        if ((user.lenderProductTypes & LenderProductTypeEnum.All) == LenderProductTypeEnum.All) {
          this.lenderList.push(user);
        }

        if (
          (user.lenderProductTypes & LenderProductTypeEnum.DevelopmentFinance) ==
            LenderProductTypeEnum.DevelopmentFinance &&
          this.actionItem.productType == ProductTypeEnum.Development
        ) {
          this.lenderList.push(user);
        }

        if (
          (user.lenderProductTypes & LenderProductTypeEnum.BridgingFinance) == LenderProductTypeEnum.BridgingFinance &&
          (this.actionItem.productType == ProductTypeEnum.Bridging ||
            this.actionItem.productType == ProductTypeEnum.BridgingPreconstruction ||
            this.actionItem.productType == ProductTypeEnum.BridgingPurchaseOrRefinance ||
            this.actionItem.productType == ProductTypeEnum.BridgingRefurb ||
            this.actionItem.productType == ProductTypeEnum.BridgingDeveloperExit)
        ) {
          this.lenderList.push(user);
        }

        if (
          (user.lenderProductTypes & LenderProductTypeEnum.CommercialMortgages) ==
            LenderProductTypeEnum.CommercialMortgages &&
          (this.actionItem.productType == ProductTypeEnum.CommercialAll ||
            this.actionItem.productType == ProductTypeEnum.CommercialInvestment ||
            this.actionItem.productType == ProductTypeEnum.CommercialOwnerOccupied)
        ) {
          this.lenderList.push(user);
        }
      }
    });
  }

  deleteSearch() {
    this.confirmSearchToDelete = false;
    this.isPageLoading = true;
    if (this.actionItem.isDevInputWithNoLogin) {
      //Introducer: Referred search, not claimed by introducee yet
      this.developmentInputWithNoLoginClient
        .markAsDeleted(this.actionItem.developmentInputId)
        .then((success) => {
          this.getSearches(this.selectedDashboardType == this.DashboardTypeEnum.Home ? this.homeScreenCount : 0);
        })
        .finally(() => {
          this.actionItem = null;
          this.isPageLoading = false;
        });
    } else {
      if (this.actionItem.productType == ProductTypeEnum.Development && this.actionItem.developmentInputId) {
        //Introducer: Referred search, claimed by introducee
        this.developmentInputClient
          .markAsDeleted(this.actionItem.developmentInputId)
          .then((success) => {
            this.getSearches(this.selectedDashboardType == this.DashboardTypeEnum.Home ? this.homeScreenCount : 0);
          })
          .finally(() => {
            this.actionItem = null;
            this.isPageLoading = false;
          });
      } else {
        this.dealClient
          .markAsDeleted(this.actionItem.dealID)
          .then((success) => {
            this.getSearches(this.selectedDashboardType == this.DashboardTypeEnum.Home ? this.homeScreenCount : 0);
          })
          .finally(() => {
            this.actionItem = null;
            this.isPageLoading = false;
          });
      }
    }
  }

  cancelCopyProject() {
    this.confirmCopyProjectName = false;
  }

  copyProjectConfirmation(dataItem) {
    this.closeTileMenu();
    event.stopPropagation();
    this.actionItem = dataItem;

    this.newProjectName = this.actionItem.caseName;

    // show popup input for new name
    this.confirmCopyProjectName = true;
  }

  copyProject() {
    this.confirmCopyProjectName = false;
    this.isPageLoading = true;

    if (this.actionItem.productType == ProductTypeEnum.Development && this.actionItem.developmentInputId) {
      this.developmentInputClient
        .copyCase(this.actionItem.developmentInputId, this.newProjectName)
        .then((response) => {
          let newCaseId = response;
          if (newCaseId) {
            this.caseMemberClient.copyShareholder(this.actionItem.caseID, newCaseId);
            this.getProjects(this.selectedDashboardType == this.DashboardTypeEnum.Home ? this.homeScreenCount : 0);
          }
        })
        .finally(() => {
          this.getProjects(this.selectedDashboardType == this.DashboardTypeEnum.Home ? this.homeScreenCount : 0);
          this.actionItem = null;
          this.isPageLoading = false;
        });
    } else {
      let productFamily = ProductFamilyEnum.Bridging;
      if ((this.actionItem.productType & ProductTypeEnum.CommercialAll) != 0) {
        productFamily = ProductFamilyEnum.Commercial;
      } else if (this.actionItem.productType == ProductTypeEnum.Development) {
        productFamily = ProductFamilyEnum.Development;
      }
      this.dealClient
        .copyCase(this.actionItem.dealID, this.newProjectName, productFamily)
        .then((response) => {
          let newCaseId = response;
          if (newCaseId) {
            //TODO: On monday make getprojects use deal model
            this.getDealproject(this.selectedDashboardType == this.DashboardTypeEnum.Home ? this.homeScreenCount : 0);
          }
        })
        .finally(() => {
          this.getProjects(this.selectedDashboardType == this.DashboardTypeEnum.Home ? this.homeScreenCount : 0);
          this.actionItem = null;
          this.isPageLoading = false;
        });
    }
  }

  deleteProjectConfirmation(dataItem) {
    this.closeTileMenu();
    event.stopPropagation();
    this.actionItem = dataItem;

    this.confirmProjectToDelete = true;
  }

  deleteProject() {
    this.confirmProjectToDelete = false;

    if (this.actionItem.productType == ProductTypeEnum.Development && this.actionItem.developmentInputId) {
      //Full case and Saved search
      this.developmentInputClient
        .markAsDeleted(this.actionItem.developmentInputId)
        .then((success) => {
          if (this.actionItem.caseID) {
            this.caseClient.markAsDeleted(this.actionItem.caseID).then((success) => {});
          }
        })
        .finally(() => {
          this.getProjects(this.selectedDashboardType == this.DashboardTypeEnum.Home ? this.homeScreenCount : 0);
          this.actionItem = null;
          this.isPageLoading = false;
        });
    } else {
      this.dealClient
        .markAsDeleted(this.actionItem.dealID)
        .then((success) => {})
        .finally(() => {
          this.getProjects(this.selectedDashboardType == this.DashboardTypeEnum.Home ? this.homeScreenCount : 0);
          this.actionItem = null;
          this.isPageLoading = false;
        });
    }
  }

  // START OF INTRODUCTIONS CODE - TO BE REVIEWED WHEN UI IS RE-WORKED

  introduceClient() {
    this.isProcessingSend = true;
    this.invite = {
      firstName: this.clientFirstName,
      email: this.clientEmail,
      lastName: this.clientSurname,
      inviteerUserId: this.currentUser.id,
      userId: null,
      phoneNumber: this.clientPhoneNumber,
      status: StatusEnum.Invited,
      guid: null,
      isDeleted: false,
      createdDateTime: null,
      lastUpdatedDateTime: null,
      createdUser: null,
      createdUserId: null,
      lastModifiedUserId: null,
      lastModifiedUser: null,
      id: null,
    };

    this.inviteClient.addUpdate(this.invite).then((response) => {
      this.invitedUsers.push(response);

      this.introducerClient
        .introduceClient(response.firstName, response.email, response.lastName, response.phoneNumber, response.guid)
        .then((success) => {
          this.introduceClientModal = 2;
          this.isPageLoading = false;
          this.isProcessingSend = false;
        })
        .finally(() => {
          delete this.clientFirstName;
          delete this.clientEmail;
          delete this.clientSurname;
          delete this.clientPhoneNumber;
        });
    });
  }

  userLookup(userSearchTerm: string) {
    this.isPageLoading = true;
    this.userService
      .searchByEmail(userSearchTerm)
      .then((response) => {
        if (this.isBroker && this.isOrganisationAdmin) {
          this.userSearchResults = response.filter(
            (x) =>
              x.organisationReferralId == this.currentUser.organisationId ||
              x.organisationId == this.currentUser.organisationId,
          );
        } else if (this.isBroker) {
          this.userSearchResults = response.filter(
            (x) =>
              x.organisationReferralId == this.currentUser.organisationId &&
              !x.organisationId &&
              !x.claimGroupsInApplicationUsers.some((cg) => cg.claimGroup?.name === "OrganisationAdmin"),
          );
        } else {
          this.userSearchResults = response;
        }
      })
      .finally(() => {
        this.isPageLoading = false;
      });
  }

  exitClientView() {
    this.selectedClientName = null;
    this.showHomeDashboard();
  }

  deleteUnsavedIntroducedSearch(loanCriteriaId: number, index: number) {
    //Introducer: Referred search, not claimed by introducee yet
    this.developmentInputWithNoLoginClient.markAsDeleted(loanCriteriaId).then((success) => {
      this.unsavedIntroducedSearches.splice(index, 1);
    });
  }

  deleteSavedIntroducedSearch(loanCriteriaId: number, index: number) {
    //Introducer: Referred search, claimed by introducee
    this.developmentInputClient.markAsDeleted(loanCriteriaId).then((success) => {
      this.savedIntroducedSearches.splice(index, 1);
    });
  }

  copyLinkToClipboard() {
    this.introducerClient.copyLinkToClipboard(this.currentUser.id).then((response) => {
      //this.link = response.toString();
      navigator.clipboard.writeText(response.toString());
      this.introduceClientModal = 7;
    });
  }

  sendLinkToUser() {
    this.introducerClient
      .sendLikToClient(this.currentUser.firstName, this.currentUser.email, this.currentUser.id)
      .then((success) => {
        this.introduceClientModal = 6;
      });
  }

  registerIntroducer() {
    this.$location.path("/registerintroducer");
  }

  inviteBorrower() {
    this.isProcessingSend = true;
    this.invite = {
      firstName: this.clientFirstName,
      email: this.clientEmail,
      lastName: this.clientSurname,
      inviteerUserId: this.currentUser.id,
      userId: null,
      phoneNumber: this.clientPhoneNumber,
      status: StatusEnum.Invited,
      guid: null,
      isDeleted: false,
      createdDateTime: null,
      lastUpdatedDateTime: null,
      createdUser: null,
      createdUserId: null,
      lastModifiedUserId: null,
      lastModifiedUser: null,
      id: null,
    };

    this.inviteClient.addUpdate(this.invite).then((response) => {
      this.invitedUsers.push(response);

      this.$user.GetUserOrganisation().then((result) => {
        if (this.invite && result) {
          this.organisationClient
            .registerBorrowers(result.uniqueRef, this.invite)
            .then((success) => {
              this.introduceClientModal = 9;
              this.dataLoading = false;
            })
            .finally(() => {
              this.introduceClientModal = 9;
              delete this.clientFirstName;
              delete this.clientEmail;
              delete this.clientSurname;
              delete this.clientPhoneNumber;
              this.isProcessingSend = false;
            });
        }
      });
    });
  }

  // END OF INTRODUCTIONS CODE - ALL INTRODUCTIONS CODE TO BE REVIEWED WHEN UI IS RE-WORKED

  openShareSearchModal(item: CaseSummaryDTO) {
    event.stopPropagation();
    this.closeTileMenu();

    // Only get the broker's/admin's users if we haven't already got it
    if (this.existingUsers.length == 0) {
      this.roleService.isBrokerOrABove().then((isBrokerOrAbove: boolean) => {
        if (isBrokerOrAbove) {
          this.getUserSummariesForBrokerOrAdmin();
        }
      });
    }

    if (item.productType == ProductTypeEnum.Development && item.developmentInputId) {
      this.isBridging = false;
      if (item.isDevInputWithNoLogin) {
        /** This will check if the result shared with new user is active */
        this.developmentInputWithNoLoginClient.isResultActive(item.uniqueRef).then((results) => {
          if (!results) {
            this.displayMsg = `Changes have been made to this search by your client, your user dashboard will now refresh`;
            this.showShareResults = 5;
          } else {
            this.developmentInputWithNoLoginClient.fetch(item.developmentInputId).then((response) => {
              this.selectedSearch = item;
              this.loanCriteria = response;
              this.selectedResult = item.developmentInputId;
              this.shareSearchModal = 3;
              this.newSearch = true;
              this.sharedSearch = false;
              this.existingborrower = null;

              if (this.loanCriteria.showLenderNamesToBorrower == null) {
                this.organisationService.getOrganisation().then((org) => {
                  this.loanCriteria.showLenderNamesToBorrower = org.showLenderNames;
                });
              }

              if ((this.roleService.isAdminUser || this.isBroker) && item.clientEmail != this.currentUser.userName) {
                this.clientFirstName = item.clientFirstName;
                this.clientSurname = item.clientSurname;
                this.clientEmail = item.clientEmail;
                this.sharedSearch = true;
              } else {
                this.clientFirstName = "";
                this.clientSurname = "";
                this.clientEmail = "";
                this.clientPhoneNumber = "";
              }
            });
          }
        });
      } else {
        this.developmentInputClient.fetch(item.developmentInputId).then((response) => {
          this.selectedSearch = item;
          this.loanCriteria = response;
          this.selectedResult = item.developmentInputId;
          this.shareSearchModal = 3;
          this.newSearch = true;
          this.sharedSearch = false;
          this.existingborrower = null;

          if (this.loanCriteria.showLenderNamesToBorrower == null) {
            this.organisationService.getOrganisation().then((org) => {
              this.loanCriteria.showLenderNamesToBorrower = org.showLenderNames;
            });
          }

          if ((this.roleService.isAdminUser || this.isBroker) && item.clientEmail != this.currentUser.userName) {
            this.clientFirstName = item.clientFirstName;
            this.clientSurname = item.clientSurname;
            this.clientEmail = item.clientEmail;
            this.sharedSearch = true;
          } else {
            this.clientFirstName = "";
            this.clientSurname = "";
            this.clientEmail = "";
            this.clientPhoneNumber = "";
          }
        });
      }
    } else {
      this.isBridging = true;
      this.selectedSearch = item;
      this.selectedResult = item.developmentInputId;
      this.shareSearchModal = 3;
      this.newSearch = true;
      this.sharedSearch = false;
      this.existingborrower = null;

      this.clientClient.fetchListByDealId(item.dealID).then((dealClients: Client[]) => {
        this.shareDealDto = {} as ShareDealDTO;
        this.shareDealDto.dealId = item.dealID;
        this.shareDealDto.dealName = item.caseName;
        this.shareDealDto.showLenderNamesAndLogos = false;
        this.shareDealDto.emailLinkToClient = false;
        this.shareDealDto.accessLevel = CaseAccessLevelEnum.FullAccess;
        this.shareDealDto.isApplicant = true;
        this.shareDealDto.isPrimary = true;

        if (dealClients && dealClients.length > 0) {
          var client = dealClients[0]; // TODO - always want to assume there's one for now until there's a redesign of sharing
          this.shareDealDto.clientDto = {} as Client;
          this.shareDealDto.clientDto.firstName = client.firstName;
          this.shareDealDto.clientDto.lastName = client.lastName;
          this.shareDealDto.clientDto.email = client.email;
          this.shareDealDto.clientDto.phoneNumber = client.phoneNumber;
          this.shareDealDto.clientDto.clientUserId = client.clientUserId;
          this.shareDealDto.clientDto.postalAddress = {
            addressLine1: "",
            addressLine2: "",
            addressLine3: "",
            addressLine4: "",
            postCode: "",
          };
          this.sharedSearch = true;
        } else {
          this.shareDealDto.clientDto = {} as Client;
          this.shareDealDto.clientDto.firstName = "";
          this.shareDealDto.clientDto.lastName = "";
          this.shareDealDto.clientDto.email = "";
          this.shareDealDto.clientDto.phoneNumber = "";
          this.shareDealDto.clientDto.postalAddress = {
            addressLine1: "",
            addressLine2: "",
            addressLine3: "",
            addressLine4: "",
            postCode: "",
          };
        }
      });
    }
  }

  /*
        introducerSendResultsToClient(notifyBorrower: boolean = true) {
            this.dataLoading = true;
            this.introducerClient.sendResultsToClient(this.selectedSearch, this.clientFirstName, this.clientSurname, this.clientEmail, notifyBorrower).then((success) => {
                this.shareSearchModal = 4;
            }).catch(reason => {
                this.shareSearchErrorDisplayed = true;
            }).finally(() => {
                this.dataLoading = false;
                delete this.clientFirstName;
                delete this.clientEmail;
                delete this.clientSurname;
                delete this.selectedSearch;
            });
        }*/

  /* introducerRefreshSearchesAndClients() {
     this.getIntroducedSearches(this.currentUser.registeredIntroducerId);
     this.clientAdminTools = true;
   }*/

  updateIntroducedClientList() {
    this.userService.getIntroducees(this.currentUser.id).then((introducedUsers) => {
      this.introducedUsers = introducedUsers;
    });
  }

  closeIntroducerClientModal() {
    this.introduceClientModal = null;
    delete this.clientFirstName;
    delete this.clientEmail;
    delete this.clientSurname;
    this.introducerErrorDisplayed = false;
  }

  closeSearchSearchModal() {
    this.shareSearchModal = null;
    this.shareSearchErrorDisplayed = false;
    delete this.selectedSearch;
  }

  isProjectClickable(isInvitedToCase: boolean) {
    // To be able to click on a project you must have one of the following:
    // 1. Paid up subcription
    // 2. Pre-cancel subscription i.e. it's been cancelled but it is still active until the end of the payment period
    // 3. subscription Payment processing i.e. they've signed up but the payment is still being processed e.g. DDs
    // 4. be a lender (no license required)
    // 5. be an admin (no license required)
    // 6. be invited to the case

    if (
      this.currentUser.subscriptionStatus == LicenseMasterStatusEnum.PaidUp ||
      this.currentUser.subscriptionStatus == LicenseMasterStatusEnum.PreCancel ||
      this.currentUser.subscriptionStatus == LicenseMasterStatusEnum.PaymentProcessing ||
      this.roleService.IsLender ||
      this.roleService.IsAdminUser ||
      isInvitedToCase == true
    ) {
      return true;
    } else {
      return false;
    }
  }

  isSearchClickable(isOwner: boolean) {
    // To be able to click on a project you must have one of the following:
    // 1. Paid up subcription
    // 2. Pre-cancel subscription i.e. it's been cancelled but it is still active until the end of the payment period
    // 3. subscription Payment processing i.e. they've signed up but the payment is still being processed e.g. DDs
    // 4. be a lender (no license required)
    // 5. be an admin (no license required)
    // 6. be an owner and a client user - we're assuming here this will identify an invited user.  This may need re-work

    if (
      this.currentUser.subscriptionStatus == LicenseMasterStatusEnum.PaidUp ||
      this.currentUser.subscriptionStatus == LicenseMasterStatusEnum.PreCancel ||
      this.currentUser.subscriptionStatus == LicenseMasterStatusEnum.PaymentProcessing ||
      this.roleService.IsLender ||
      this.roleService.IsAdminUser ||
      (isOwner == true && this.roleService.IsClient)
    ) {
      return true;
    } else {
      return false;
    }
  }

  signout() {
    this.authService.logout(true);
  }

  getStatusTextForLender(caseLenderState: CaseLenderStateEnum, IsBidAccepted: boolean): string {
    var statusText = CaseLenderHelper.getStatusTextForLender(caseLenderState, IsBidAccepted);
    return statusText;
  }

  /** closes share pop up*/
  cancelNewSearch() {
    this.newSearch = false;
    this.clearInputFields();
  }

  clearInputFields() {
    this.clientFirstName = null;
    this.clientEmail = null;
    this.clientSurname = null;
    this.clientPhoneNumber = null;
    this.showClientDetails = false;
    this.selecteduserName = null;
    this.selectedBorrowerId = null;
  }

  getUserSummariesForBrokerOrAdmin() {
    this.userService
      .getUserSummariesForBrokerOrAdmin()
      .then((response) => {
        this.existingUsers = response;
      })
      .finally(() => {});
  }

  getBrokerBelongToOrganisation(orgId): void {
    this.organisationClient.getAllOrganisationMembers(orgId).then((orgBrokers: ApplicationUser[]) => {
      this.licensedOrganisationBrokers = orgBrokers.filter((x) => x.subscriptionStatus > 0);
    });
  }

  viewClientsDashboardForNewSearch(id: number) {
    //Look up client's account details
    this.odataHelper
      .getOne(this.applicationUserCrudClient, {
        filter: { id: { eq: id } },
        select: {
          id: true,
          email: true,
          firstName: true,
          lastName: true,
          phoneNumber: true,
        },
      })
      .then((user) => {
        if (this.selectedSearch.productType == ProductTypeEnum.Development && this.selectedSearch.dealID == null) {
          this.clientFirstName = user.firstName;
          this.clientEmail = user.email;
          this.clientSurname = user.lastName;
          this.clientPhoneNumber = user.phoneNumber;
          this.clientId = user.id;
          this.showClientDetails = true;
        } else {
          this.shareDealDto.isApplicant = true;
          this.shareDealDto.isPrimary = true;
          this.shareDealDto.clientDto.firstName = user.firstName;
          this.shareDealDto.clientDto.email = user.email;
          this.shareDealDto.clientDto.lastName = user.lastName;
          this.shareDealDto.clientDto.phoneNumber = user.phoneNumber;
          this.shareDealDto.clientDto.clientUserId = user.id;
          this.showClientDetails = true;
        }
      });
  }

  sendResultsToClient(notifyBorrower) {
    this.dataLoading = true;
    this.newSearch = false;
    this.existingborrower = null;
    this.showClientDetails = false;

    if (this.selectedSearch.productType == ProductTypeEnum.Development && this.selectedSearch.developmentInputId) {
      this.userService
        .getUserDetailsByEmailIfExists(this.clientEmail)
        .then((user: ApplicationUser) => {
          if (user == null) {
            this.loanCriteria.userId = null;
            this.introducerClient
              .sendResultsToClient(
                this.clientFirstName,
                this.clientSurname,
                this.clientEmail,
                notifyBorrower,
                this.clientPhoneNumber,
                this.loanCriteria,
              )
              .then((success) => {
                this.showShareResults = 2;
              });
          } else {
            this.clientId = user.id;
            if (!this.selectedSearch.isDevInputWithNoLogin) {
              this.developmentInputClient
                .sendResultsToExistingClient(
                  this.clientFirstName,
                  this.clientSurname,
                  this.clientEmail,
                  this.clientId,
                  notifyBorrower,
                  this.clientPhoneNumber,
                  this.loanCriteria,
                )
                .then((success) => {
                  this.showShareResults = 3;
                });
            } else {
              const result = {} as DevelopmentInputWithNoLogin;
              (<any>Object).assign(result, this.loanCriteria);
              this.developmentInputWithNoLoginClient
                .sendResultsToExistingClient(
                  this.clientFirstName,
                  this.clientSurname,
                  this.clientEmail,
                  this.clientId,
                  notifyBorrower,
                  this.clientPhoneNumber,
                  result,
                )
                .then((success) => {
                  this.showShareResults = 3;
                });
            }
          }
        })
        .finally(() => {
          delete this.clientFirstName;
          delete this.clientEmail;
          delete this.clientSurname;
          delete this.clientPhoneNumber;
          delete this.clientId;
          this.dataLoading = false;
        });
    } else {
      this.shareDealDto.clientDto.postalAddress = this.shareDealDto.clientDto.postalAddress ?? {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        postCode: "",
      };
      this.dealClient
        .shareDeal(this.shareDealDto)
        .then(() => {
          this.getSearches(this.selectedDashboardType == this.DashboardTypeEnum.Home ? this.homeScreenCount : 0);
        })
        .finally(() => {
          delete this.shareDealDto;
          this.dataLoading = false;
        });
    }
  }

  /* sendResultsToExistingClient(notifyBorrower: boolean = true, showMsgAfterResultSent: boolean = true) {
             this.newSearch = false;
             this.existingborrower = null;
             this.showClientDetails = false;
             this.developmentInputClient.sendResultsToExistingClient(this.loanCriteria, this.clientFirstName, this.clientSurname, this.clientEmail, this.clientId, notifyBorrower, this.clientPhoneNumber).then((success) => {
                 delete this.clientFirstName;
                 delete this.clientEmail;
                 delete this.clientSurname;
                 delete this.clientPhoneNumber;
                 delete this.clientId;
                 this.showShareResults = 3;
             });
         }
 
 
         introducerSendResultsToClient(notifyBorrower: boolean = true) {
             this.newSearch = false;
             this.existingborrower = null;
             this.showClientDetails = false;
 
             // remove the user id because otherwise the client won't be able to see the search on their dashboard
             this.loanCriteria.userId = null;
 
             this.introducerClient.sendResultsToClient(this.loanCriteria, this.clientFirstName, this.clientSurname, this.clientEmail, notifyBorrower, this.clientPhoneNumber).then((success) => {
                 delete this.clientFirstName;
                 delete this.clientEmail;
                 delete this.clientSurname;
                 delete this.clientPhoneNumber;
                 if (this.isBroker) {
                     this.showShareResults = 2;
                 } else {
                     this.showShareResults = 1;
                 }
             });
         }
         */

  sendShareSearchEmailToClient() {
    this.dataLoading = true;

    if (this.selectedSearch.productType == ProductTypeEnum.Development && this.selectedSearch.developmentInputId) {
      if (this.loanCriteria.introduceeFirstName == null || this.loanCriteria.introduceeSurname == null) {
        this.loanCriteria.introduceeFirstName = this.clientFirstName;
        this.loanCriteria.introduceeSurname = this.clientSurname;
      }
      if (this.selectedSearch.isDevInputWithNoLogin) {
        this.developmentInputWithNoLoginClient
          .sendEmailToNewUser(this.loanCriteria.uniqueRef, this.loanCriteria.showLenderNamesToBorrower, true)
          .then((response) => {
            this.displayMsg =
              "Search results have been sent to " +
              this.loanCriteria.introduceeFirstName +
              " " +
              this.loanCriteria.introduceeSurname;
            this.newSearch = false;
            this.showShareResults = 4;
            this.dataLoading = false;
          })
          .catch((error) => {
            this.displayMsg = "Sorry, something went wrong. Please try again.";
            this.newSearch = false;
            this.showShareResults = 4;
            this.dataLoading = false;
          })
          .finally(() => {
            delete this.selectedSearch;
            delete this.loanCriteria;
            delete this.selectedResult;
            delete this.shareSearchModal;
            delete this.existingborrower;
            delete this.clientFirstName;
            delete this.clientSurname;
            delete this.clientEmail;
          });
      } else {
        this.developmentInputClient
          .sendEmailToExistingUser(this.loanCriteria.id, this.loanCriteria.showLenderNamesToBorrower, true)
          .then((response) => {
            this.displayMsg =
              "Search results have been sent to " +
              this.loanCriteria.introduceeFirstName +
              " " +
              this.loanCriteria.introduceeSurname;
            this.newSearch = false;
            this.showShareResults = 4;
            this.dataLoading = false;
          })
          .catch((error) => {
            this.displayMsg = "Sorry, something went wrong. Please try again.";
            this.newSearch = false;
            this.showShareResults = 4;
            this.dataLoading = false;
          });
      }
    } else {
      this.shareDealDto.emailLinkToClient = true;
      this.dealClient
        .shareDeal(this.shareDealDto)
        .then((response) => {
          this.displayMsg =
            "Search results have been sent to " +
            this.shareDealDto.clientDto.firstName +
            " " +
            this.shareDealDto.clientDto.lastName;
          this.newSearch = false;
          this.showShareResults = 4;
          this.dataLoading = false;
        })
        .finally(() => {
          delete this.selectedSearch;
          delete this.loanCriteria;
          delete this.selectedResult;
          delete this.shareSearchModal;
          delete this.existingborrower;
          delete this.shareDealDto;
        });
    }
  }

  reloadPage() {
    window.location.reload();
  }

  viewClientsDashboard(userName: string) {
    //Look up client's account details
    this.dataLoading = true;
    this.userService.searchByEmail(userName).then((users) => {
      this.showHomeDashboard();
      this.dataLoading = false;
    });
  }

  sendMessageToBrokerAdmin(message) {
    this.dataLoading = true;
    this.borrowerMessage = null;
    this.organisationClient
      .sendBorrowerMessageToOrganisationAdmin(
        this.currentUser.defaultBrokerOrganisationId,
        message,
        this.currentUser.firstName,
        this.currentUser.lastName,
        this.currentUser.email,
        ProductTypeEnum.Development,
        "USERDASHBOARD",
      )
      .then((results) => {
        if (results) {
          this.displayMsg = `Message has been sent successfully.`;
          this.showMessageToborrower = true;
          this.showContactBrokerModal = false;
        } else {
          this.displayMsg = `There is problem sending a message, Please try later.`;
          this.showMessageToborrower = true;
          this.showContactBrokerModal = false;
        }
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  closeDeletedSearchMessageModal() {
    this.showDeletedSearchMessageModal = false;
    this.showMessageToborrower = false;
    this.showContactBrokerModal = false;
    this.displayMsg = null;
    sessionStorage.removeItem("returningFromdeletedSearch");
  }

  /**
   * Toggles the display of the context menu on the tile for searches/cases
   * @param id
   */
  toggleTileMenu(id) {
    event.stopPropagation();
    this.closeAddMenu();
    this.cardWithOpenMenu.id = this.cardWithOpenMenu.id == id ? null : id;
  }

  /**
   * Toggles the display of the Add Item menu
   * @param event
   */
  toggleAddMenu(event) {
    event.stopPropagation();

    if (this.isBroker && !this.currentUser.hasActiveSubscription) {
      return;
    }
    this.closeTileMenu();

    var menu = document.getElementsByClassName("new-item-menu").item(0) as HTMLElement;

    if (menu && (menu.style.display == "none" || menu.style.display == "")) {
      var boundingRect = event.target.getBoundingClientRect();
      var offsetHeight = event.target.offsetHeight;

      menu.style.display = "flex";
      menu.style.left = boundingRect.left - menu.clientWidth - 10 + "px";
      menu.style.bottom = offsetHeight + "px";
    } else {
      if (menu) {
        menu.style.display = "none";
      }
    }
  }

  /**Closes the context menu on search/case tiles */
  closeTileMenu() {
    this.cardWithOpenMenu.id = null;
  }

  /**Closes the Add new item menu */
  closeAddMenu() {
    var menu = document.getElementsByClassName("new-item-menu").item(0) as HTMLElement;

    if (menu) {
      menu.style.display = "none";
    }
  }

  /**Closes all context menus */
  closeContextMenus() {
    this.closeTileMenu();
    this.closeAddMenu();
  }

  getProductTypeText(productType: ProductTypeEnum, isRegulatedBridge: boolean = false) {
    if (isRegulatedBridge) {
      return "regulated bridge";
    } else {
      var productTypeInfo = this.productTypeOptions.find((p) => p.key == productType);

      if (productTypeInfo) {
        return productTypeInfo.displayName;
      }
    }

    return "";
  }

  /** Determines whether to show the "no searches" message on the user dashboard */
  showNoSearchesMessage(): boolean {
    return this.searches?.length == 0 && !this.isSearchesLoading;
  }

  /** Determines whether to show the "no cases" message on the user dashboard */
  showNoCasesMessage(): boolean {
    if (this.selectedNavMenu == NavMenuEnum.DevelopmentFinance) {
      return this.projects.length == 0 && !this.isDevFinanceProjectsLoading;
    } else if (this.selectedNavMenu == NavMenuEnum.BridgingFinance) {
      return this.projects.length == 0 && !this.isBridgingPreConProjectsLoading;
    } else if (this.selectedNavMenu == NavMenuEnum.CommercialMortgages) {
      return this.projects.length == 0 && !this.isCommercialProjectsLoading;
    } else if (this.selectedNavMenu == NavMenuEnum.Home && !this.isAllProjectsLoading) {
      return this.projects && this.projects.length == 0 && !this.isAllProjectsLoading;
    }
  }

  /**Determines whether to show the case loading spinner */
  showCasesLoadingSpinner(): boolean {
    if (this.selectedNavMenu == NavMenuEnum.DevelopmentFinance) {
      return !this.projects || this.isDevFinanceProjectsLoading;
    } else if (this.selectedNavMenu == NavMenuEnum.BridgingFinance) {
      return !this.projects || this.isBridgingPreConProjectsLoading;
    } else if (this.selectedNavMenu == NavMenuEnum.CommercialMortgages) {
      return !this.projects || this.isCommercialProjectsLoading;
    } else if (this.selectedNavMenu == NavMenuEnum.Home) {
      return !this.projects || this.isAllProjectsLoading;
    }
  }

  /** Determines whether to show the list of Case cards*/
  showCaseCards(): boolean {
    return this.projects != null && this.projects != undefined;
  }

  returnCaseOrDealId(item: CaseSummaryDTO): number {
    if (item.productType == ProductTypeEnum.Development && item.caseID) {
      return item.caseID;
    } else {
      return item.dealID;
    }
  }

  returnSearchOrDealId(item: CaseSummaryDTO): number {
    if (item.productType == ProductTypeEnum.Development && item.developmentInputId) {
      return item.developmentInputId;
    } else {
      return item.dealID;
    }
  }

  setHasBridgingAndHasCommercialValue(): void {
    this.organisationClient.getOrganisationProductAccess().then((response) => {
      this.hasBridging = response.hasBridging;
      this.hasCommercial = response.hasCommercial;
      this.isDeallockerIntegrationEnabled = response.isDeallockerIntegrationEnabled;
    });
  }

  currentLenderProductType(): void {
    this.hideBridgingMenu = true;
    this.hideDevfinanceMenu = true;
    this.hideCommercialMenu = true;

    this.lenderClient.getLenderProductTypes().then((response) => {
      if (this.currentUser != null && this.currentUser.lenderProductTypes != null) {
        // When the current user is a lender admin then they should see all product types that the lender has
        if (this.currentUser.isLenderAdmin) {
          if (response == LenderProductTypeEnum.All) {
            this.hideBridgingMenu = false;
            this.hideDevfinanceMenu = false;
            this.hideCommercialMenu = false;

            return;
          }

          if ((response & LenderProductTypeEnum.DevelopmentFinance) == LenderProductTypeEnum.DevelopmentFinance) {
            this.hideDevfinanceMenu = false;
          }

          if ((response & LenderProductTypeEnum.BridgingFinance) == LenderProductTypeEnum.BridgingFinance) {
            this.hideBridgingMenu = false;
          }

          if ((response & LenderProductTypeEnum.CommercialMortgages) == LenderProductTypeEnum.CommercialMortgages) {
            this.hideCommercialMenu = false;
          }

          return;
        } else {
          // If the lender has all product types and the lender user has been set up to see all products types
          if (
            response == LenderProductTypeEnum.All &&
            (this.currentUser.lenderProductTypes & LenderProductTypeEnum.All) == LenderProductTypeEnum.All
          ) {
            this.hideBridgingMenu = false;
            this.hideDevfinanceMenu = false;
            this.hideCommercialMenu = false;

            return;
          }

          if (
            (response & LenderProductTypeEnum.DevelopmentFinance) == LenderProductTypeEnum.DevelopmentFinance &&
            ((this.currentUser.lenderProductTypes & LenderProductTypeEnum.DevelopmentFinance) ==
              LenderProductTypeEnum.DevelopmentFinance ||
              (this.currentUser.lenderProductTypes & LenderProductTypeEnum.All) == LenderProductTypeEnum.All)
          ) {
            this.hideDevfinanceMenu = false;
          }

          if (
            (response & LenderProductTypeEnum.BridgingFinance) == LenderProductTypeEnum.BridgingFinance &&
            ((this.currentUser.lenderProductTypes & LenderProductTypeEnum.BridgingFinance) ==
              LenderProductTypeEnum.BridgingFinance ||
              (this.currentUser.lenderProductTypes & LenderProductTypeEnum.All) == LenderProductTypeEnum.All)
          ) {
            this.hideBridgingMenu = false;
          }

          if (
            (response & LenderProductTypeEnum.CommercialMortgages) == LenderProductTypeEnum.CommercialMortgages &&
            ((this.currentUser.lenderProductTypes & LenderProductTypeEnum.CommercialMortgages) ==
              LenderProductTypeEnum.CommercialMortgages ||
              (this.currentUser.lenderProductTypes & LenderProductTypeEnum.All) == LenderProductTypeEnum.All)
          ) {
            this.hideCommercialMenu = false;
          }

          //if (response == LenderProductTypeEnum.All && (this.currentUser.lenderProductTypes & LenderProductTypeEnum.BridgingFinance) == LenderProductTypeEnum.BridgingFinance && (this.currentUser.lenderProductTypes & LenderProductTypeEnum.DevelopmentFinance) == LenderProductTypeEnum.DevelopmentFinance && (this.currentUser.lenderProductTypes & LenderProductTypeEnum.CommercialMortgages) == LenderProductTypeEnum.CommercialMortgages) {
          //    this.hideBridgingMenu = false;
          //    this.hideDevfinanceMenu = false;
          //    this.hideCommercialMenu = false;
          //} else if ((response == LenderProductTypeEnum.All && (this.currentUser.lenderProductTypes & LenderProductTypeEnum.All) == LenderProductTypeEnum.All) || (response == LenderProductTypeEnum.All && this.currentUser.isLenderAdmin)) {
          //    this.hideBridgingMenu = false;
          //    this.hideDevfinanceMenu = false;
          //    this.hideCommercialMenu = false;
          //} else if ((response == LenderProductTypeEnum.BridgingFinance || response == LenderProductTypeEnum.All) && ((this.currentUser.lenderProductTypes & LenderProductTypeEnum.BridgingFinance) == LenderProductTypeEnum.BridgingFinance || this.currentUser.isLenderAdmin)) {
          //    this.hideBridgingMenu = false;
          //} else if ((response == LenderProductTypeEnum.DevelopmentFinance || response == LenderProductTypeEnum.All) && ((this.currentUser.lenderProductTypes & LenderProductTypeEnum.DevelopmentFinance) == LenderProductTypeEnum.DevelopmentFinance || this.currentUser.isLenderAdmin)) {
          //    this.hideDevfinanceMenu = false;
          //} else if ((response == LenderProductTypeEnum.CommercialMortgages || response == LenderProductTypeEnum.All) && ((this.currentUser.lenderProductTypes & LenderProductTypeEnum.CommercialMortgages) == LenderProductTypeEnum.CommercialMortgages || this.currentUser.isLenderAdmin)) {
          //    this.hideCommercialMenu = false;
          //}
          //else if (response == LenderProductTypeEnum.DevelopmentFinance && ((this.currentUser.lenderProductTypes & LenderProductTypeEnum.All) == LenderProductTypeEnum.All || this.currentUser.isLenderAdmin)) {
          //    this.hideDevfinanceMenu = false;
          //} else if (response == LenderProductTypeEnum.BridgingFinance && ((this.currentUser.lenderProductTypes & LenderProductTypeEnum.All) == LenderProductTypeEnum.All || this.currentUser.isLenderAdmin)) {
          //    this.hideBridgingMenu = false;
          //} else if (response == LenderProductTypeEnum.CommercialMortgages && ((this.currentUser.lenderProductTypes & LenderProductTypeEnum.All) == LenderProductTypeEnum.All || this.currentUser.isLenderAdmin)) {
          //    this.hideCommercialMenu = false;
          //}
        }
      }
    });
  }

  showViewButton(productType: ProductTypeEnum) {
    if (
      productType == ProductTypeEnum.Development ||
      ((productType == ProductTypeEnum.Bridging ||
        productType == ProductTypeEnum.BridgingPreconstruction ||
        productType == ProductTypeEnum.BridgingPurchaseOrRefinance ||
        productType == ProductTypeEnum.BridgingRefurb ||
        productType == ProductTypeEnum.BridgingDeveloperExit) &&
        this.hasBridging) ||
      ((productType == ProductTypeEnum.CommercialAll ||
        productType == ProductTypeEnum.CommercialInvestment ||
        productType == ProductTypeEnum.CommercialOwnerOccupied) &&
        this.hasCommercial)
    ) {
      return true;
    }

    return false;
  }

  onPlusButtonHover(event) {
    if (this.isBroker) {
      event.currentTarget.children[0].style.display = "";
    }
  }

  goToDealForum(item) {
    if (this.isLender) {
      if (this.goToDealForumClicked) {
        sessionStorage.setItem("lenderTask", "feedback");
        this.goToDealForumClicked = false;
        if (item.productType == ProductTypeEnum.Development) {
          if (item.dealID) {
            this.$location.path("/devfinanceheadsofterm/" + item.dealID + "/" + item.dealLenderId);
          } else {
            this.$location.path("/headsofterm/" + item.caseID + "/" + item.dealLenderId);
          }
        } else if (
          item.productType == ProductTypeEnum.CommercialAll ||
          item.productType == ProductTypeEnum.CommercialInvestment ||
          item.productType == ProductTypeEnum.CommercialOwnerOccupied
        ) {
          this.$location.path("/commercialheadsofterm/" + item.dealID + "/" + item.dealLenderId);
        } else if (
          item.productType == ProductTypeEnum.BridgingPreconstruction ||
          item.productType == ProductTypeEnum.BridgingPurchaseOrRefinance ||
          item.productType == ProductTypeEnum.BridgingDeveloperExit ||
          item.productType == ProductTypeEnum.BridgingRefurb ||
          item.productType == ProductTypeEnum.Bridging
        ) {
          this.$location.path("/bridgingheadsofterm/" + item.dealID + "/" + item.dealLenderId);
        }
      } else {
        this.goToDealForumClicked = true;
        this.lenderSelectedProject = { ...item };
        this.showLenderTerms = true;
      }
    } else {
      if (item.productType == ProductTypeEnum.Development && item.dealID == null) {
        this.$location.path("/lending/" + item.caseID);
      } else {
        this.$location.path("/dealforum/" + item.dealID);
      }
    }
  }

  getTotalUnreadMessagesPerAppraisal() {
    if (this.projects && this.projects.length > 0) {
      let appraisalList: AppraisalData[] = this.projects.map((obj) => ({
        appraisalId: obj.dealID != null ? obj.dealID : obj.caseID,
        isDeal: obj.dealID != null ? true : false,
        brokerUserId: obj.brokerUserId,
      }));

      this.dealLenderMessageClient.getTotalUnreadMessagesPerAppraisal(appraisalList).then((response) => {
        for (const proj of this.projects) {
          const matchingProj =
            proj.dealID != null
              ? response.find((dl) => dl.appraisalId === proj.dealID && dl.isDeal)
              : response.find((dl) => dl.appraisalId === proj.caseID && !dl.isDeal);
          if (matchingProj) {
            proj.totalUnreadMessages = matchingProj.totalUnreadMessages;
          }
        }
      });
    }
  }

  //If previous path is any one of these then only it restore previous selected navmenu and filter
  isValidPreviousPath() {
    if (
      ((this.$rootScope as any).previousRoute.startsWith("/commercialresults") ||
        (this.$rootScope as any).previousRoute.startsWith("/bridgingresults") ||
        (this.$rootScope as any).previousRoute.startsWith("/devfinanceresults") ||
        (this.$rootScope as any).previousRoute.startsWith("/commercialcasedashboard") ||
        (this.$rootScope as any).previousRoute.startsWith("/bridgingcasedashboard") ||
        (this.$rootScope as any).previousRoute.startsWith("/devfinancecasedashboard") ||
        (this.$rootScope as any).previousRoute == "/" ||
        (this.$rootScope as any).previousRoute.startsWith("/devfinancecriteria") ||
        (this.$rootScope as any).previousRoute.startsWith("/bridgingcriteria") ||
        (this.$rootScope as any).previousRoute.startsWith("/commercialcriteria") ||
        (this.$rootScope as any).previousRoute.startsWith("/referredSearch") ||
        (this.$rootScope as any).previousRoute.startsWith("/casedashboard") ||
        (this.$rootScope as any).previousRoute.startsWith("/results") ||
        (this.$rootScope as any).previousRoute.startsWith("/dealforum") ||
        (this.$rootScope as any).previousRoute.startsWith("/lending")) &&
      (this.$rootScope as any).previousRoute != "/"
    ) {
      return true;
    }
    return false;
  }

  onSelectingHomeMenu() {
    sessionStorage.removeItem("selectedNavMenu");
  }

  logExportDownload(eventName, item: CaseSummaryDTO) {
    this.eventLogClient.logEvent(
      eventName,
      EventLogEnum.Export,
      item.productType,
      item.dealID ? item.dealID : item.caseID,
    );
  }

  async initializeUserRoles() {
    try {
      const result = await this.roleService.GetUserRoles();

      this.isAdmin = result.some((x) => x.toLowerCase() === "admin");
      this.isBroker = result.some((x) => x.toLowerCase() === "broker");
      this.isBorrower = result.some((x) => x.toLowerCase() === "client");
      this.isIntroducer = result.some((x) => x.toLowerCase() === "introducer");
      this.isLender = result.some((x) => x.toLowerCase() === "lender");
      this.isOrganisationAdmin = result.some((x) => x.toLowerCase() === "organisationadmin");

      if (this.isAdmin) {
        this.getBrokerOrganisations();
      }

      await this.setCurrentUserDetails();

      await this.getorganisationBrokers();
      await this.configureMenus();
      await this.setupLenderDetails();
      await this.handleHubspotIntegration();

      if (!(this.$rootScope as any).clientUsernameBeingViewed) {
        this.selecteduserName = this.currentUser.userName;
      }

      const goToNavMenu = this.userDashboardService.getGoToNavMenu();
      if (goToNavMenu) {
        if (goToNavMenu == this.userDashboardService.NavMenuEnum.EquityAndMezz) {
          this.showEquityAndMezzDashboard();
        }
      } else {
        this.showHomeDashboard();
      }

      this.isPageLoading = false;
    } catch (error) {
      console.error("Error initializing user roles:", error);
      this.isPageLoading = false;
    }
  }

  async setCurrentUserDetails() {
    this.currentUser = await this.getCurrentUser();

    const licenseData = await this.indexService.currentUserLicenseData;
    this.currentUser.hasActiveEnterpriseLicense = licenseData.hasActiveEnterpriseLicense;
    this.currentUser.subscriptionStatus = licenseData.subscriptionStatus;
    this.hasEnterpriseLicense = this.currentUser.hasActiveEnterpriseLicense;
    this.currentUser.hasActiveSubscription = HasActiveLicense(this.currentUser.subscriptionStatus);
    if (this.currentUser?.isConnectUser) {
      this.filterStatuses.push({ id: 9, value: "Case to Review", order: 9 });
    }
  }

  async getorganisationBrokers() {
    if (this.isOrganisationAdmin) {
      await this.getBrokerBelongToOrganisation(this.currentUser.organisationId);
    }
  }

  async configureMenus() {
    if (this.isBroker || this.isBorrower) {
      this.hideDevfinanceMenu = false;
      this.hideBridgingMenu = false;
      this.hideCommercialMenu = false;
      await this.setHasBridgingAndHasCommercialValue();
    } else {
      this.hasBridging = true;
      this.hasCommercial = true;
      if (!this.isAdmin && !this.isIntroducer) {
        await this.currentLenderProductType();
      } else {
        this.hideDevfinanceMenu = false;
        this.hideBridgingMenu = false;
        this.hideCommercialMenu = false;
      }
    }

    if (this.isAdmin || this.isBroker) {
      const response = await this.organisationClient.getOrganisationProductAccess();
      if (this.isAdmin) {
        this.isDeallockerIntegrationEnabled = response.isDeallockerIntegrationEnabled;
      }
      this.isProfessionalServicesEnabled = response.isProfessionalServicesEnabled;

      if ((this.isBroker && response.isConnectMember) || this.isAdmin) {
        this.filterStatuses.push({ id: 9, value: "Sent to Packager", order: 9 });
      }
    }
  }

  async setupLenderDetails() {
    if (!this.isLender) return;

    this.hideDevelopmentFinanceSearch = true;
    this.hideBridgingSearch = true;
    this.hideCommercialSearch = true;
    this.hasLiveSearch = false;

    const lender = await this.lenderClient.getUserLenderDetails();
    if (lender.hasLiveMarketSearch) {
      this.hasLiveSearch = true;

      if (lender.hasBridgingSearch) {
        this.hideBridgingMenu = false;
        this.hideBridgingSearch = false;
      }
      if (lender.hasDevelopmentFinanceSearch) {
        this.hideDevfinanceMenu = false;
        this.hideDevelopmentFinanceSearch = false;
      }
      if (lender.hasCommercialSearch) {
        this.hideCommercialMenu = false;
        this.hideCommercialSearch = false;
      }
    }

    this.isProfessionalServicesEnabled = lender.isProfessionalServicesEnabled;
    this.lenderUsers = await this.userService.getUsersByLenderId(this.currentUser.lenderId);
  }

  async handleHubspotIntegration() {
    if (!this.addToHubspot) return;

    const hubspotContactRequest: HubspotContactRequest = {
      user: this.currentUser,
      page: "",
      login: false,
      orgCode: "",
      role: UserRoleEnum.None,
      organisationLinkId: 0,
      productType: ProductTypeEnum.None,
      dealId: null,
      developmentInputWithNoLoginUniqueRef: "",
      clientId: null,
    };
    await this.userService.sendEventToHubspot(hubspotContactRequest);
  }

  sendVATBridgingLeadEmail() {
    this.isPageLoading = true;
    this.userService
      .sendVATBridgingLeadEmail(this.vatBridgingPurchasePrice, false)
      .then(() => {
        this.displayMsg = "VAT Bridging quote requested!";
        this.showShareResults = 4;
        this.vatBridgingPurchasePrice = null;
        this.acceptTerms = false;
        // Reset form state
        this.getQuoteForm.$setPristine();
        this.getQuoteForm.$setUntouched();
      })
      .catch((error) => {
        this.displayMsg = "Error while requesting a quote. Please try again later.";
        this.showShareResults = 4;
      })
      .finally(() => {
        this.isPageLoading = false;
      });
  }

  getBrokerOrganisations() {
    try {
      this.odataHelper
        .getMany(this.organisationCrudClient, {
          select: {
            id: true,
            name: true,
          },
          orderBy: ["name"],
        })
        .then((res) => {
          this.brokerOrganisations = res;
        });
    } catch (response) {
      this.displayMsg = "Error loading broker organisations";
    }
  }
}
